import { IApplicantConstant, IThirdPartyConstantGtwy } from './types';

export const ApplicantTypes: IApplicantConstant[] = [
  { text: 'Жилец', value: 'tenant' },
  { text: 'Сотрудник', value: 'employee' },
  { text: 'Стороннее лицо', value: 'other' },
];

export const OtherTypes: IThirdPartyConstantGtwy[] = [
  { text: 'Частное лицо', value: 'other_person' },
  { text: 'Представитель организации', value: 'other_employee' },
];
